module.exports = __webpack_public_path__ + "src/components/Feedback/mind.png?33fad75d";


//////////////////
// WEBPACK FOOTER
// ./src/components/Feedback/mind.png
// module id = 2789
// module chunks = 1